<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Seller Delivery Method'"
          :fields="fields"
          :items="data"
          :redirectDetail="false"
          :enableAddButton="true"
          :removeButton="true"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @removeData="removeData"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="delivery">Delivery Method</label>
              <model-select
                class="form-control"
                id="delivery"
                :options="deliveryMethodList"
                v-model="$v.deliveryMethodForm.delivery.$model"
                :isError="$v.deliveryMethodForm.delivery.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.deliveryMethodForm.delivery.$invalid"
                class="invalid-feedback-custom"
              >
                Delivery Method should be filled.
              </div>
            </div>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.deliveryMethodForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "DeliveryMethod",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "DeliveryMethod",
      items: [],
      addButton: false,
      deliveryMethodForm: tableInterfaces.agent_delivery_method,
      isLoading: false,
      activeTab: 0,
      //   checkedFlag: "Agent",
      fields: [
        { key: "agent_code", label: "Seller Code", sorter: true },
        { key: "delivery_method", label: "Delivery Method", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    agent: {
      type: [Array, Object],
      default: () => [],
    },
    deliveryMethodList: {
      type: [Array, Object],
      default: () => [],
    },
    agentdeliveryMethod: {
      type: [Array, Object],
      default: () => [],
    },
    agentStatus: {
      type: String,
      default: "",
    },
  },
  validations: {
    deliveryMethodForm: {
      agent_code: {},
      delivery: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.agentdeliveryMethod;
    },
  },
  methods: {
    init: function () {},
    refreshAgentDelivery: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/agent/agent_delivery_method/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
          
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    removeData: function (item) {
      if (confirm("Do you want to remove this data ?")) {
        this.isLoading = true;
        this.axios
          .delete("console/agent/agent_delivery_method/" + item.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshAgentDelivery(this.agent.id);
          });
      }
      // bikin api untuk remove
    },
    resetForm: function () {
      for (var i in tableInterfaces.agent_delivery_method) {
        tableInterfaces.agent_delivery_method[i] = null;
      }
      this.deliveryMethodForm = tableInterfaces.agent_delivery_method;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.deliveryMethodForm.agent_code = this.agent.agent_code;
      if (confirm("Do you want to add this data ?")) {
        this.isLoading = true;
        this.axios
          .post(
            "console/agent/agent_delivery_method/add",
            this.deliveryMethodForm
          )
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshAgentDelivery(this.agent.id);
          });
      }
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
